import captionService from "CaptionService";
import type { CaptionRecord } from "./types";

export const menu: CaptionRecord = {
  more: () => captionService.getString("cb8b9690-969a-44d0-9cec-0b4083d3dde1", "More"),
  actions: () => captionService.getString("13591db9-2610-456a-8657-533c09d48cd2", "Actions"),
  bulkActions: () => captionService.getString("0910fb6c-3e7e-4b2f-8c32-4286f6abc582", "Bulk actions"),
};
